import {registerAPIService} from './APIServicesRegistry';
import APIServiceBase from './APIServiceBase';
import axios from 'axios'

export default class ConfigurationAPIService extends APIServiceBase {
    constructor(endpointControllerName) {
        super(endpointControllerName || 'Configuration')
    }

    getDocumentationModalContent(data) {
        return this.post('GetDocumentationModalContent', data)
    }

    generateDocumentation(data) {
        return this.post('GenerateDocument', data, 'blob')
    }

    generateXlsDocumentation(data) {
        return this.post('GenerateXlsDocument', data, 'blob')
    }

    saveConfiguration(data) {
        if (data.id === 0) {
            return this.post('Create', data)
        }

        return this.post(`Edit/${data.id}`, data)
    }

    saveNewConfiguration(data) {
        return this.post('Create', data)
    }

    configure(data) {
        return this.post('Configure', data)
    }

    calculateHeatExchanger(data) {
        return this.post('CalculateHeatExchanger', data)
    }

    delete(id) {
        return this.get(`Delete?id=${id}`)
    }

    deleteBatch(data) {
        return this.post('DeleteBatch', data)
    }

    copy(id) {
        return this.get(`Copy?id=${id}`)
    }

    generateSpecificForOrderProcessing() {
        return this.get(`GetXlsDocumentationModalContent`)
    }

    getFileCollection(data) {
        return this.post('GetFileCollection', data)
    }

    getModulesByModuleNumber(data) {
        return this.post('getModulesByModuleNumber', data);
    }

    getModuleNumbersByDescription(data) {
        return this.post('GetModulesByDescription', data);
    }

    importModuleXls(data, model) {
        return this.post('ImportModuleXls', data, model);
    }

    exportModuleXls(model) {
        return this.post('ExportModuleXls', model, 'blob');
    }

    configurePricing(pricingModel) {
        return this.post('ConfigurePricing', pricingModel);
    }


}

registerAPIService(ConfigurationAPIService)